import type { RootState } from '../store';

export const selectScale = (state: RootState) => state.panZoom.scale;
export const selectTranslateX = (state: RootState) => state.panZoom.translateX;
export const selectTranslateY = (state: RootState) => state.panZoom.translateY;
export const selectIsPanningMode = (state: RootState) => state.panZoom.isPanningMode;
export const selectPanZoomState = (state: RootState) => state.panZoom;
